import React, { useEffect, useMemo } from "react"
// import { StyleSheet } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from "~/ui/styled"
import { Flex, CenterFlex, ColumnFlex, StartFlex, Text, IconFont } from "~components/El"
import Select from "../components/Select"
import { SelfDestructTimeSettingsScreenProps } from "./types"
import { useStores } from "~models"
import {
  MESSAGE_DESTRUCT_TIME_OPTIONS,
  getMessageDestructOptionLabel,
} from "./msg-destruct-time-options"

const Container = styled(ColumnFlex)`
  flex-direction: column;
  height: auto;
  flex: 1;
  padding: 0 12px;
`

const SectionTitle = styled.Text`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryText};
  padding: 12px 0 10px;
`

const Dotted = styled(CenterFlex)`
  width: 4px;
  height: 4px;
  margin-right: 10px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.primaryText};
`

const tips = [
  "消息自毁功能仅对新发送的消息生效",
  "已发送的消息不会受到设置变更的影响",
  "消息删除后无法恢复，请谨慎使用",
  "图片和文件也会一同删除",
]

const SelfDestructTimeSettings: React.FC<SelfDestructTimeSettingsScreenProps> = ({ route }) => {
  void route
  const theme = useTheme()
  const { settingStore, walletStore } = useStores()

  useEffect(() => {
    walletStore.getMessageDestroySetting()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- MobX root store stable
  }, [])

  const currentOption =
    walletStore.msg_destruct_option != null &&
    walletStore.msg_destruct_option >= 1 &&
    walletStore.msg_destruct_option <= 6
      ? walletStore.msg_destruct_option
      : 4
  const selectedValue = String(currentOption)

  const previewSentence = useMemo(() => {
    const label = getMessageDestructOptionLabel(currentOption)
    if (walletStore.msg_destruct_enabled !== true) {
      return `消息定时自毁已关闭 · 已选预设：${label}`
    }
    return `消息将在 ${label} 后自动删除`
  }, [walletStore.msg_destruct_enabled, currentOption])

  return (
    <Container>
      <ColumnFlex
        height="auto"
        width="100%"
        mt="10px"
        padding="10px 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <SectionTitle>当前设置</SectionTitle>
        <StartFlex height="auto" alignItems="center">
          <IconFont name="sssj" size={18} color={theme.colors.primary} />
          <Text ml="8px" color={theme.colors.primaryText} fontSize={theme.fontSizes.md} lineHeight="22px">
            {previewSentence}
          </Text>
        </StartFlex>
      </ColumnFlex>

      <ColumnFlex
        height="auto"
        width="100%"
        mt="10px"
        padding="0 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <Select
          title="预设时间"
          options={MESSAGE_DESTRUCT_TIME_OPTIONS}
          value={selectedValue}
          onChange={(val) => {
            const n = Number(val)
            if (n >= 1 && n <= 6) settingStore.setMessageDestructOption(n)
          }}
        />
      </ColumnFlex>
      <Flex height="auto" flexDirection="column" width="100%" mt="10px" padding="10px 12px" borderRadius="8px" bg="rgba(78, 152, 243, 0.1)">
        <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.md} fontWeight="600">
          <IconFont name="jilu" size={12} color={theme.colors.purpleBackground} />
          &nbsp;&nbsp;说明
        </Text>
        <Flex height="auto" flexDirection="column" width="100%" mt="10px" pl="26px">
          {tips.map((text, index) => (
            <StartFlex height="auto" key={index}>
              <Dotted />
              <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.sm} lineHeight="18px">
                {text}
              </Text>
            </StartFlex>
          ))}
        </Flex>
      </Flex>
    </Container>
  )
}

export default observer(SelfDestructTimeSettings)
